// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Loader = require("../../../uikit/reason/atoms/Loader/Loader.bs.js");
var MainLayout = require("../components/MainLayout.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var UserSession = require("./UserSession.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var UserSessionFetchErrorMessage = require("./UserSessionFetchErrorMessage.bs.js");

function LoggedInAgent$Provider(props) {
  var __loaderComponent = props.loaderComponent;
  var loaderComponent = __loaderComponent !== undefined ? Caml_option.valFromOption(__loaderComponent) : JsxRuntime.jsx(Loader.make, {});
  var initState = UserSession.useInitState();
  switch (initState) {
    case "NotCalled" :
    case "Loading" :
        return loaderComponent;
    case "Agent" :
        return props.children;
    default:
      return JsxRuntime.jsx(MainLayout.make, {
                  children: JsxRuntime.jsx(UserSessionFetchErrorMessage.make, {})
                });
  }
}

var Provider = {
  make: LoggedInAgent$Provider
};

var provider = LoggedInAgent$Provider;

exports.Provider = Provider;
exports.provider = provider;
/* Loader Not a pure module */
